import React, { useRef, useState } from 'react'
import emailjs from 'emailjs-com';
import './contact.css'
import phone from './../../image/phone-call.png'
import map from './../../image/map.png' ;
import email from './../../image/email.png' ;



function Contact() {


  const formRef = useRef()
  const [done, setDone] = useState(false);


  const handelSubmit = (e) => {
    e.preventDefault();


    emailjs.sendForm('service_6jqeqq8', 'template_k7r94i7', formRef.current, 'user_yOkCbJtj1vtKcePnPijYz')
      .then((result) => {
        console.log(result.text);
        setDone(true);
      }, (error) => {
        console.log(error.text);
      });


  }

  return (
    <div className='c'>
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Let's discuss your project</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={phone} className="c-icon" alt="" />
              +20 114 648 5778
            </div>
            <div className="c-info-item">
              <img src={email} className="c-icon" alt="" />
              ahmedelsayed3157@gmail.com
            </div>
            <div className="c-info-item">
              <img src={map} className="c-icon" alt="" />
              Egypt , Cairo
            </div>
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>What's your story ?</b> Lorem, ipsum dolor sit amet consectetur adipisicing elit. Obcaecati possimus soluta autem asperiores, libero sunt dolore recusandae quo ut voluptate nesciunt dolor ab quia deserunt quisquam quos iusto, expedita architecto.

          </p>
          <form ref={formRef} onSubmit={handelSubmit}>
            <input type="text" placeholder="Name" name="user_name" />
            <input type="text" placeholder="Subject" name="user_subject" />
            <input type="email" placeholder="Email" name="user_email" />
            <textarea name="message" rows="5" placeholder="Message" />
            <button>Submit</button>
            {done && <h1>Thank you for Send email😄</h1>}
          </form>
        </div>
      </div>
    </div>
  )
}

export default Contact
